import React, { useState } from 'react';
import { Cpu, RefreshCw, CheckCircle2 } from 'lucide-react';

export const ProstheticsModule: React.FC = () => {
  const [sensitivity, setSensitivity] = useState(85);
  const [gaitSymmetry, setGaitSymmetry] = useState(94);
  const [calibratedMsg, setCalibratedMsg] = useState('');

  const handleRecalibrate = () => {
    setCalibratedMsg('Myoelectric sensor gain & gait telemetry auto-calibrated!');
    setTimeout(() => setCalibratedMsg(''), 4000);
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-indigo-100 text-indigo-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            Bionic Prosthetics & Exoskeleton Fitting
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Bionic Prosthetics, Orthotics & Exoskeleton Fitting</h2>
          <p className="text-xs text-slate-500">Myoelectric EMG sensor calibration, gait analysis telemetry, and prosthetic fitting</p>
        </div>

        <button 
          onClick={handleRecalibrate}
          className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-bold text-xs rounded-xl shadow transition flex items-center gap-1.5"
        >
          <RefreshCw className="w-4 h-4" />
          <span>Auto-Calibrate EMG Gain</span>
        </button>
      </div>

      {calibratedMsg && (
        <div className="p-3 bg-emerald-50 border border-emerald-200 text-emerald-900 rounded-xl text-xs font-bold flex items-center gap-2">
          <CheckCircle2 className="w-4 h-4 text-emerald-600" />
          {calibratedMsg}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-xs font-bold text-slate-700">Myoelectric EMG Gain Sensitivity</span>
            <span className="text-sm font-black text-indigo-600 font-mono">{sensitivity}% Gain</span>
          </div>
          <input 
            type="range" min="10" max="100" value={sensitivity}
            onChange={(e) => setSensitivity(parseInt(e.target.value))}
            className="w-full accent-indigo-600"
          />
        </div>

        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-xs font-bold text-slate-700">Gait Telemetry Symmetry Index</span>
            <span className="text-sm font-black text-emerald-600 font-mono">{gaitSymmetry}% Symmetrical</span>
          </div>
          <input 
            type="range" min="50" max="100" value={gaitSymmetry}
            onChange={(e) => setGaitSymmetry(parseInt(e.target.value))}
            className="w-full accent-emerald-600"
          />
        </div>
      </div>
    </div>
  );
};
